module.exports = __webpack_public_path__ + "static/media/favorite_black_with_item.74c18748.svg";